import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { useCalTheme } from "./useCalTheme";

/** The one card surface: glass on dark, paper on light, soft depth, a lift on hover when `interactive`. */
export function CalSurface({ interactive, children, ...rest }: BoxProps & { interactive?: boolean }) {
  const t = useCalTheme();
  return (
    <Box
      bg={t.surface}
      borderWidth="1px"
      borderColor={t.border}
      borderRadius={t.radius}
      boxShadow={t.shadow}
      backdropFilter={t.glass}
      p={{ base: 4, md: 5 }}
      transition="box-shadow .2s ease, border-color .2s ease, background .2s ease"
      _hover={interactive ? { boxShadow: t.shadowHover, borderColor: t.borderStrong } : undefined}
      minW={0}
      {...rest}
    >
      {children}
    </Box>
  );
}
